'use strict';

var SeasonalityAnalysisCalendarDetailsDirective = function SeasonalityAnalysisCalendarDetailsDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/seasonality-analysis-calendar-details.html')
  };
};
SeasonalityAnalysisCalendarDetailsDirective.$inject = [];
module.exports = SeasonalityAnalysisCalendarDetailsDirective;